import type {
	CustomItem,
	DropQuoteType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropQuote = (item: Item | CustomItem): item is DropQuoteType => {
	return !!(item && item.__typename === 'Drop_Quote');
};
